var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ComingSoon extends Component {
    constructor() {
        super('ComingSoon', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const colors = ['--bs-orange', '--bs-primary'];
            $('.page-template-page-template-coming-soon').css('--color-main', 'var(' + colors[Math.floor(Math.random() * colors.length)] + ')');
            $('#btn-toggle-newsletter').on('click', (event, button) => {
                event.preventDefault();
                button.toggleClass('active');
                $('.panel-newsletter').toggleClass('d-none');
            });
            $('#btn-close-newsletter-ok').on('click', (event, button) => {
                event.preventDefault();
                $('#btn-toggle-newsletter').removeClass('active');
                $('.panel-newsletter-ok').addClass('d-none');
            });
            this.success();
        });
    }
}
